export default __webpack_public_path__ + "img/Minus.c9802454.svg";